import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["componentId", "parentId", "beforeId"],
  _excluded2 = ["nodeIds", "parentId", "beforeId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { filter } from '@beef/utils';
import { traverse } from "../traverse";
import { LibraryFactory } from "../library/factory";
import { ChainBuilder } from "../props/ChainBuilder";
import { NodeExtension } from "../props/node/NodeExtension";
import { ActiveValue, ListOfIdentifiers, Value } from "../values";
import { AttachNodeVisitor, BuildParentTreeVisitor, ChangeActiveVisitor, ChangePropVisitor, ChangeStyleVisitor, CloneCopiedNodesVisitor, CollectParentGroupsVisitor, DetachNodeVisitor, ObtainNodeInfoVisitor } from "../visitors";
import { AdaptiveExtension, FieldsExtension, StylesExtension, ValueGroupExtension } from "../props";
import { CircularReferenceError, EntangledChildrenException } from "../common/Errors";
import { setDifference } from "./helpers";
import { NodeTreeExtension } from "../props/node-tree/NodeTreeExtension";
import { AdaptiveSizeNames } from "../props/adaptive/constants";

// FIXME: Заменить на CommandHandler'ы
var CoreInterface = /*#__PURE__*/function () {
  function CoreInterface(coreDSL, factory) {
    _classCallCheck(this, CoreInterface);
    this.coreDSL = coreDSL;
    this.factory = factory;
    _defineProperty(this, "rootVisitable", void 0);
    this.rootVisitable = factory.create(coreDSL, {});
  }
  _createClass(CoreInterface, [{
    key: "serialize",
    value: function serialize() {
      return this.factory.serialize(this.rootVisitable);
    }
  }, {
    key: "createProjection",
    value: function createProjection(params) {
      return this.factory.createProjection(this.coreDSL, params);
    }
  }, {
    key: "accept",
    value: function accept(plugin) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var result = traverse(this.rootVisitable, plugin, {
        opts: opts
      });
      // FIXME: временный костыль для обновления проекции
      this.coreDSL = this.factory.serialize(this.rootVisitable);
      return result;
    }

    /**
     * Retrieve info about current node for nodeTree within provided parameters
     */
  }, {
    key: "getFixedNodeInfo",
    value: function getFixedNodeInfo(nodeId, contextParams) {
      return this.accept(ObtainNodeInfoVisitor, _objectSpread({
        nodeId: nodeId
      }, contextParams));
    }
  }, {
    key: "getParentTree",
    value: function getParentTree(params) {
      return this.accept(BuildParentTreeVisitor, params).parentTree;
    }
  }, {
    key: "isMoveAllowed",
    value: function isMoveAllowed(_ref) {
      var nodeIds = _ref.nodeIds,
        parentId = _ref.parentId,
        maxSize = _ref.maxSize,
        _ref$fieldId = _ref.fieldId,
        fieldId = _ref$fieldId === void 0 ? 'children' : _ref$fieldId;
      if (!parentId) return false;
      var nodeTree = this.getParentTree({
        maxSize: maxSize,
        fieldId: fieldId
      });
      return !nodeIds.some(function (nodeId) {
        return nodeTree.isAncestor(parentId, nodeId);
      });
    }
  }, {
    key: "createNode",
    value: function createNode(params) {
      var componentId = params.componentId,
        parentId = params.parentId,
        beforeId = params.beforeId,
        filterParams = _objectWithoutProperties(params, _excluded);
      // если создается не для root элемента, то без родителя не создаем
      if (!this.rootVisitable.isEmpty() && !parentId) {
        throw new Error('Create operation is not allowed, most likely parent does not accept children');
      }
      var _this$accept = this.accept(AttachNodeVisitor, {
          componentId: componentId,
          parentId: parentId,
          beforeId: beforeId,
          fieldId: 'children'
        }),
        nodeId = _this$accept.nodeId;
      // Сперва отключаем узел везде
      this.accept(ChangeActiveVisitor, {
        nodeIds: [nodeId],
        value: false
      });

      // Потом включаем в выбранном интервале
      this.accept(ChangeActiveVisitor, _objectSpread(_objectSpread({
        nodeIds: [nodeId]
      }, filterParams), {}, {
        value: true
      }));
      return nodeId;
    }
  }, {
    key: "moveNode",
    value: function moveNode(params) {
      var nodeIds = params.nodeIds,
        parentId = params.parentId,
        beforeId = params.beforeId,
        targetParams = _objectWithoutProperties(params, _excluded2);
      if (!nodeIds.length) throw new Error('`moveNode` command missing `nodeId`');
      if (!this.isMoveAllowed({
        nodeIds: nodeIds,
        parentId: parentId,
        fieldId: 'children',
        maxSize: params.maxSize
      })) {
        throw new CircularReferenceError();
      }
      this.accept(DetachNodeVisitor, _objectSpread(_objectSpread({}, targetParams), {}, {
        nodeIds: nodeIds,
        removeNode: false
      }));
      this.accept(AttachNodeVisitor, _objectSpread(_objectSpread({}, targetParams), {}, {
        nodeIds: nodeIds,
        fieldId: 'children',
        parentId: parentId,
        beforeId: beforeId
      }));
    }
  }, {
    key: "cloneCopiedNodes",
    value: function cloneCopiedNodes(params) {
      var nodeIds = params.nodeIds,
        nodes = params.nodes,
        parentId = params.parentId,
        beforeId = params.beforeId,
        maxSize = params.maxSize,
        minSize = params.minSize;
      if (!nodeIds.length) throw new Error('`cloneNodes` command missing `nodeIds`');
      var _this$accept2 = this.accept(CloneCopiedNodesVisitor, {
          nodes: nodes
        }),
        mappedNodeIds = _this$accept2.mappedNodeIds;
      var clonedNodeIds = nodeIds.map(function (oldNodeId) {
        return mappedNodeIds[oldNodeId];
      });
      this.accept(AttachNodeVisitor, {
        nodeIds: clonedNodeIds,
        fieldId: 'children',
        parentId: parentId,
        beforeId: beforeId
      });

      // Отключаем узлы выше активного интервала
      if (maxSize && maxSize !== AdaptiveSizeNames.GLOBAL) {
        this.accept(ChangeActiveVisitor, {
          nodeIds: clonedNodeIds,
          minSize: maxSize,
          value: false
        });
      }

      // Отключаем узлы ниже активного интервала
      if (minSize) {
        this.accept(ChangeActiveVisitor, {
          nodeIds: clonedNodeIds,
          maxSize: minSize,
          value: false
        });
      }
      return mappedNodeIds;
    }

    /**
     * При копировании узла, копируются также все вложенные в него узлы
     *
     * Важно отметить, что выбранные узлы должны быть полностью изолированы от остальной структуры,
     *   иначе клонирование будет невозможным
     */
  }, {
    key: "deepCopyNodes",
    value: function deepCopyNodes(_ref2) {
      var nodeIds = _ref2.nodeIds;
      var nestedNodeIds = this.collectDeeplyNestedNodes({
        nodeIds: nodeIds
      });
      var clone = this.factory.serialize(this.rootVisitable);
      var isOneOfNodeIds = function isOneOfNodeIds(nodeId) {
        return nestedNodeIds.indexOf(nodeId) !== -1;
      };

      // NOTE: возможно раскрывать "особенности структуры DSL" не очень хорошая идея
      //   однако в текущий момент это сильно упрощает реализацию
      return filter(clone, function (_, nodeId) {
        return isOneOfNodeIds(nodeId);
      });
    }

    /**
     * Если структура узлов сложная - например некоторые узлы вложены в родителя в одних параметрах,
     *   а в других находятся в другом узле, то для удаления нужно делать много параметрических действий
     *
     * Для реализации полноценного алгоритма нужно переписать логику хранения узлов друг в друге, перейдя на parentId,
     *   сейчас же для упрощения принято ограничение, что узел можно удалить, если все вложенные в него узлы,
     *   всегда являются его дочерними
     */
  }, {
    key: "deleteNodes",
    value: function deleteNodes(_ref3) {
      var nodeIds = _ref3.nodeIds;
      var nestedNodeIds = this.collectDeeplyNestedNodes({
        nodeIds: nodeIds
      });
      this.accept(DetachNodeVisitor, {
        nodeIds: nestedNodeIds,
        removeNode: true
      });
    }

    /**
     * Helper-функция позволяет собрать все узлы, вложенные в заданные изначально
     */
  }, {
    key: "collectDeeplyNestedNodes",
    value: function collectDeeplyNestedNodes(_ref4) {
      var nodeIds = _ref4.nodeIds;
      var _this$accept3 = this.accept(CollectParentGroupsVisitor),
        parents = _this$accept3.parents,
        children = _this$accept3.children;
      var isIntendedDelete = function isIntendedDelete(nodeId) {
        return nodeIds.indexOf(nodeId) !== -1;
      };
      var collectedNodesIds = new Set(nodeIds);
      var parentNodeIds = new Set();
      /**
       * Проверяем есть ли узлы, которые не во всех наборах параметров находятся внутри удаляемых
       */
      collectedNodesIds.forEach(function (nodeId) {
        var _children$nodeId;
        (_children$nodeId = children[nodeId]) === null || _children$nodeId === void 0 ? void 0 : _children$nodeId.forEach(function (params) {
          return collectedNodesIds.add(params.nodeId);
        });
        if (isIntendedDelete(nodeId)) return;
        parents[nodeId].forEach(function (params) {
          if (!params.nodeId) return;
          parentNodeIds.add(params.nodeId);
        });
      });

      // Если хотя бы один узел принадлежит иному узлу, то выкидываем ошибку
      if (setDifference(parentNodeIds, collectedNodesIds).size) {
        throw new EntangledChildrenException();
      }
      return _toConsumableArray(collectedNodesIds);
    }
  }, {
    key: "changeActive",
    value: function changeActive(params) {
      this.accept(ChangeActiveVisitor, params);
    }
  }, {
    key: "changeProp",
    value: function changeProp(params) {
      this.accept(ChangePropVisitor, params);
    }
  }, {
    key: "changeStyle",
    value: function changeStyle(params) {
      this.accept(ChangeStyleVisitor, params);
    }
  }]);
  return CoreInterface;
}();
export { CoreInterface as default };
export var createCoreFactory = function createCoreFactory(coreDSL, libraryDSL) {
  var library = LibraryFactory.createLibrary(libraryDSL);
  return new CoreInterface(coreDSL, ChainBuilder.from(new NodeExtension({
    children: ChainBuilder.from(ListOfIdentifiers).with(new ValueGroupExtension()).with(new AdaptiveExtension()).with(new FieldsExtension(library.getNodeFieldGroups())),
    props: ChainBuilder.from(Value).with(new ValueGroupExtension()).with(new AdaptiveExtension()).with(new FieldsExtension(library.getDataFieldGroups())),
    active: ChainBuilder.from(ActiveValue).with(new ValueGroupExtension()).with(new AdaptiveExtension()),
    styles: ChainBuilder.from(Value).with(new ValueGroupExtension()).with(new AdaptiveExtension()).with(new StylesExtension())
  })).with(new NodeTreeExtension()));
};